window.customElements.whenDefined('ui-editor').then(() => {
    window.customizeEditor = uiEditor => {
        let editor = uiEditor.editor;
        let toolbar = uiEditor.querySelector('ui-toolbar');

        // Workaround until https://github.com/livewire/flux/issues/746 is fixed
        editor.extensionManager.extensions.filter(extension => extension.name == 'link')[0].options.protocols = ['mailto', 'page', 'procedure', 'legislation'];
        editor.setOptions();

        // Web Link
        if (toolbar.querySelector('[data-editor="web-link"]')) {
            toolbar.querySelector('[data-editor="web-link:url"]')?.addEventListener('keydown', e => {
                if (['ArrowLeft', 'ArrowRight'].includes(e.key) || /^[a-zA-Z0-9]$/.test(e.key)) {
                    e.stopPropagation();
                }
            })

            toolbar.querySelector('[data-editor="web-link:url"]')?.addEventListener('input', e => e.stopPropagation())
            toolbar.querySelector('[data-editor="web-link:url"]')?.addEventListener('change', e => e.stopPropagation())

            let insertLink = () => {
                let url = toolbar.querySelector('[data-editor="web-link:url"]')?.value?.trim()

                if (url) {
                    editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
                } else {
                    editor.chain().focus().unsetLink().run()
                }
            }

            toolbar.querySelector('[data-editor="web-link:insert"]')?.addEventListener('click', insertLink)
            toolbar.querySelector('[data-editor="web-link:url"]')?.addEventListener('keydown', e => ['Enter'].includes(e.key) && insertLink())

            toolbar.querySelector('[data-editor="web-link:unlink"]')?.addEventListener('click', () => {
                editor.chain().focus().unsetLink().run()
            })
        }

        // Email Link
        if (toolbar.querySelector('[data-editor="email-link"]')) {
            toolbar.querySelector('[data-editor="email-link:url"]')?.addEventListener('keydown', e => {
                if (['ArrowLeft', 'ArrowRight'].includes(e.key) || /^[a-zA-Z0-9]$/.test(e.key)) {
                    e.stopPropagation();
                }
            })

            toolbar.querySelector('[data-editor="email-link:url"]')?.addEventListener('input', e => e.stopPropagation())
            toolbar.querySelector('[data-editor="email-link:url"]')?.addEventListener('change', e => e.stopPropagation())

            let insertLink = () => {
                let url = toolbar.querySelector('[data-editor="email-link:url"]')?.value?.trim()

                if (url) {
                    editor.chain().focus().extendMarkRange('link').setLink({ href: 'mailto:' + url }).run()
                } else {
                    editor.chain().focus().unsetLink().run()
                }
            }

            toolbar.querySelector('[data-editor="email-link:insert"]')?.addEventListener('click', insertLink)
            toolbar.querySelector('[data-editor="email-link:url"]')?.addEventListener('keydown', e => ['Enter'].includes(e.key) && insertLink())

            toolbar.querySelector('[data-editor="email-link:unlink"]')?.addEventListener('click', () => {
                editor.chain().focus().unsetLink().run()
            })
        }

        // Page Link
        if (toolbar.querySelector('[data-editor="page-link"]')) {
            toolbar.querySelector('[data-flux-editor-page-link-select]')?.addEventListener('input', e => e.stopPropagation())
            toolbar.querySelector('[data-flux-editor-page-link-select]')?.addEventListener('change', e => e.stopPropagation())
            toolbar.querySelector('[data-flux-editor-page-link-select]')?.addEventListener('select', e => e.stopPropagation())
            toolbar.querySelector('[data-flux-editor-page-link-select]')?.addEventListener('click', e => e.stopPropagation())

            let insertLink = () => {
                let url = toolbar.querySelector('[data-editor="page-link:url"]')?.value?.trim()

                if (url) {
                    editor.chain().focus().extendMarkRange('link').setLink({ href: 'page://' + url }).run()
                } else {
                    editor.chain().focus().unsetLink().run()
                }
            }

            toolbar.querySelector('[data-editor="page-link:insert"]')?.addEventListener('click', insertLink)

            toolbar.querySelector('[data-editor="page-link:unlink"]')?.addEventListener('click', () => {
                editor.chain().focus().unsetLink().run()
            })
        }

        // Legislation Link
        if (toolbar.querySelector('[data-editor="legislation-link"]')) {
            toolbar.querySelector('[data-editor="legislation-link:url"]')?.addEventListener('keydown', e => {
                if (['ArrowLeft', 'ArrowRight'].includes(e.key) || /^[a-zA-Z0-9]$/.test(e.key)) {
                    e.stopPropagation();
                }
            })

            toolbar.querySelector('[data-editor="legislation-link:url"]')?.addEventListener('input', e => e.stopPropagation())
            toolbar.querySelector('[data-editor="legislation-link:url"]')?.addEventListener('change', e => e.stopPropagation())

            let insertLink = () => {
                let url = toolbar.querySelector('[data-editor="legislation-link:url"]')?.value?.trim()

                if (url) {
                    editor.chain().focus().extendMarkRange('link').setLink({ href: 'legislation://' + url }).run()
                } else {
                    editor.chain().focus().unsetLink().run()
                }
            }

            toolbar.querySelector('[data-editor="legislation-link:insert"]')?.addEventListener('click', insertLink)
            toolbar.querySelector('[data-editor="legislation-link:url"]')?.addEventListener('keydown', e => ['Enter'].includes(e.key) && insertLink())

            toolbar.querySelector('[data-editor="legislation-link:unlink"]')?.addEventListener('click', () => {
                editor.chain().focus().unsetLink().run()
            })
        }

        // Procedure Link
        if (toolbar.querySelector('[data-editor="procedure-link"]')) {
            toolbar.querySelector('[data-editor="procedure-link:url"]')?.addEventListener('keydown', e => {
                if (['ArrowLeft', 'ArrowRight'].includes(e.key) || /^[a-zA-Z0-9]$/.test(e.key)) {
                    e.stopPropagation();
                }
            })

            toolbar.querySelector('[data-editor="procedure-link:url"]')?.addEventListener('input', e => e.stopPropagation())
            toolbar.querySelector('[data-editor="procedure-link:url"]')?.addEventListener('change', e => e.stopPropagation())

            let insertLink = () => {
                let url = toolbar.querySelector('[data-editor="procedure-link:url"]')?.value?.trim()

                if (url) {
                    editor.chain().focus().extendMarkRange('link').setLink({ href: 'procedure://' + url }).run()
                } else {
                    editor.chain().focus().unsetLink().run()
                }
            }

            toolbar.querySelector('[data-editor="procedure-link:insert"]')?.addEventListener('click', insertLink)
            toolbar.querySelector('[data-editor="procedure-link:url"]')?.addEventListener('keydown', e => ['Enter'].includes(e.key) && insertLink())

            toolbar.querySelector('[data-editor="procedure-link:unlink"]')?.addEventListener('click', () => {
                editor.chain().focus().unsetLink().run()
            })
        }

        let updateToolbar = () => {
            let webLinkInput = toolbar.querySelector('[data-editor="web-link:url"]')
            let emailLinkInput = toolbar.querySelector('[data-editor="email-link:url"]')
            let pageLinkInput = toolbar.querySelector('[data-editor="page-link:url"]')
            let legislationLinkInput = toolbar.querySelector('[data-editor="legislation-link:url"]')
            let procedureLinkInput = toolbar.querySelector('[data-editor="procedure-link:url"]')

            let webLinkButton = toolbar.querySelector('[data-editor="web-link"] [data-match-target]')
            let emailLinkButton = toolbar.querySelector('[data-editor="email-link"] [data-match-target]')
            let pageLinkButton = toolbar.querySelector('[data-editor="page-link"] [data-match-target]')
            let legislationLinkButton = toolbar.querySelector('[data-editor="legislation-link"] [data-match-target]')
            let procedureLinkButton = toolbar.querySelector('[data-editor="procedure-link"] [data-match-target]')

            let disableButtonAndResetInput = (button, input, prop) => {
                button && setAttribute(button, 'disabled', '')
                button && removeAndReleaseAttribute(button, 'data-match', '')
                input ? input.value = '' : null
                input && prop ? Alpine.$data(input)[prop] = null : null
            }

            let resetButtonAndInput = (button, input, prop) => {
                button && removeAndReleaseAttribute(button, 'disabled', '')
                button && removeAndReleaseAttribute(button, 'data-match', '')
                input ? input.value = '' : null
                input && prop ? Alpine.$data(input)[prop] = null : null
            }

            let enableAndHighlightButton = (button) => {
                button && removeAndReleaseAttribute(button, 'disabled', '')
                button && setAttribute(button, 'data-match', '')
            }

            if (editor.isActive('link')) {
                let href = editor.getAttributes('link').href

                if (href.startsWith('procedure://')) {
                    enableAndHighlightButton(procedureLinkButton)

                    let attrs = editor.getAttributes('link')
                    let value = (attrs.href || '').replace('procedure://', '');
                    procedureLinkInput.value = value;
                    Alpine.$data(procedureLinkInput).procedureId = value;

                    disableButtonAndResetInput(webLinkButton, webLinkInput)
                    disableButtonAndResetInput(emailLinkButton, emailLinkInput)
                    disableButtonAndResetInput(pageLinkButton, pageLinkInput)
                    disableButtonAndResetInput(legislationLinkButton, legislationLinkInput)
                } else if (href.startsWith('legislation://')) {
                    enableAndHighlightButton(legislationLinkButton)

                    let attrs = editor.getAttributes('link')
                    let value = (attrs.href || '').replace('legislation://', '');
                    legislationLinkInput.value = value;
                    Alpine.$data(legislationLinkInput).legislationId = value;

                    disableButtonAndResetInput(webLinkButton, webLinkInput)
                    disableButtonAndResetInput(emailLinkButton, emailLinkInput)
                    disableButtonAndResetInput(pageLinkButton, pageLinkInput)
                    disableButtonAndResetInput(procedureLinkButton, procedureLinkInput)
                } else if (href.startsWith('page://')) {
                    enableAndHighlightButton(pageLinkButton)

                    let attrs = editor.getAttributes('link')
                    let value = (attrs.href || '').replace('page://', '');
                    Alpine.$data(pageLinkInput).pageId = value;

                    disableButtonAndResetInput(webLinkButton, webLinkInput)
                    disableButtonAndResetInput(emailLinkButton, emailLinkInput)
                    disableButtonAndResetInput(procedureLinkButton, procedureLinkInput)
                    disableButtonAndResetInput(legislationLinkButton, legislationLinkInput)
                } else if (href.startsWith('mailto:')) {
                    enableAndHighlightButton(emailLinkButton)

                    let attrs = editor.getAttributes('link')
                    emailLinkInput.value = (attrs.href || '').replace('mailto:', '');

                    disableButtonAndResetInput(webLinkButton, webLinkInput)
                    disableButtonAndResetInput(pageLinkButton, pageLinkInput)
                    disableButtonAndResetInput(procedureLinkButton, procedureLinkInput)
                    disableButtonAndResetInput(legislationLinkButton, legislationLinkInput)
                } else {
                    enableAndHighlightButton(webLinkButton)

                    let attrs = editor.getAttributes('link')
                    webLinkInput.value = attrs.href || ''

                    disableButtonAndResetInput(emailLinkButton, emailLinkInput)
                    disableButtonAndResetInput(pageLinkButton, pageLinkInput)
                    disableButtonAndResetInput(procedureLinkButton, procedureLinkInput)
                    disableButtonAndResetInput(legislationLinkButton, legislationLinkInput)
                }
            } else {
                resetButtonAndInput(webLinkButton, webLinkInput)
                resetButtonAndInput(emailLinkButton, emailLinkInput)
                resetButtonAndInput(pageLinkButton, pageLinkInput, 'pageId')
                resetButtonAndInput(procedureLinkButton, procedureLinkInput, 'procedureId')
                resetButtonAndInput(legislationLinkButton, legislationLinkInput, 'legislationId')
            }

        };

        uiEditor.editor.on('transaction', updateToolbar);
        uiEditor.editor.on('selectionUpdate', updateToolbar);
    }

    // Workaround until https://github.com/livewire/flux/issues/746 is fixed
    document.querySelectorAll('ui-editor').forEach(uiEditor => window.customizeEditor(uiEditor));
});

/**
 * The following code is copied from '../../vendor/livewire/flux-pro/dist/editor.module.js'
 */

function setAttribute(el, name, value) {
    if (el._durableAttributeObserver === void 0) {
        el._durableAttributeObserver = attributeObserver(el, [name]);
    }
    if (!el._durableAttributeObserver.hasAttribute(name)) {
        el._durableAttributeObserver.addAttribute(name);
    }
    el._durableAttributeObserver.pause(() => {
        el.setAttribute(name, value);
    });
}
function removeAndReleaseAttribute(el, name) {
    removeAttribute(el, name);
    releaseAttribute(el, name);
}
function removeAttribute(el, name) {
    if (el._durableAttributeObserver === void 0) {
        el._durableAttributeObserver = attributeObserver(el, [name]);
    }
    if (!el._durableAttributeObserver.hasAttribute(name)) {
        el._durableAttributeObserver.addAttribute(name);
    }
    el._durableAttributeObserver.pause(() => {
        el.removeAttribute(name);
    });
}
function releaseAttribute(el, name) {
    if (!el?._durableAttributeObserver?.hasAttribute(name)) return;
    el._durableAttributeObserver.releaseAttribute(name);
}
